<script lang="ts">
  /**
   * Аватарка учасника: фото або ініціал.
   *
   * Той самий патерн уже лежав інлайном у шести місцях адмінки й профілю
   * (AdminDashboardPage, AdminUserDetailPage, AdminActivityPage, ProfilePage,
   * HomeBanner). Коментарі додали б сьоме й восьме — тож витягнуто сюди.
   *
   * onerror обов'язковий: посилання на фото з Telegram CDN протухають, і без
   * фолбеку замість людини лишається піктограма «зламане зображення».
   */
  interface Props {
    photo: string | null | undefined;
    name: string;
    size?: number;
  }
  let { photo, name, size = 36 }: Props = $props();

  let broken = $state(false);

  // Скидаємо позначку, коли компонент перевикористали під іншу людину:
  // без цього зламане фото попереднього автора лишило б ініціал новому.
  $effect(() => {
    void photo;
    broken = false;
  });

  const initial = $derived((name.trim().charAt(0) || '?').toUpperCase());
  const showPhoto = $derived(!!photo && !broken);
</script>

<div class="avatar" style:width="{size}px" style:height="{size}px" style:font-size="{Math.round(size * 0.4)}px">
  {#if showPhoto}
    <img src={photo} alt="" loading="lazy" onerror={() => (broken = true)} />
  {:else}
    <span aria-hidden="true">{initial}</span>
  {/if}
</div>

<style>
  .avatar {
    flex-shrink: 0;
    border-radius: 50%;
    overflow: hidden;
    background: var(--sand-soft);
    color: var(--text-muted);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    line-height: 1;
    user-select: none;
  }
  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
</style>
